export const siteConfig = {
  brand: "Hindi with Prabha",
  tagline: "Speak Hindi confidently, live India fully",
  teacherName: "Prabha Jha",
  whatsappNumber: "919910444691",
  whatsappDisplayNumber: "+91 9910444691",
  whatsappMessage: "Namaste, I want to book a trial hindi class.",
  whatsappCtaLabel: "Book free trial",
  email: "prabhajha5@gmail.com",
  city: "New Delhi, India (online worldwide)",
  callHours: "10:00 AM to 8:30 PM IST",
  linkedinUrl: "https://www.linkedin.com/in/prabha-jha-82569b331?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  youtubeUrl: "https://www.youtube.com/@Storybyprabha",
  spotifyPodcastUrl: "https://open.spotify.com/episode/7DaO57m5yp4sImJUmXBFWl?si=vzq4B-SDRbKwyQeDCmRceg",
  applePodcastUrl: "https://podcasts.apple.com/us/podcast/story-garden-with-prabha/id6802348323",
};

export const getWhatsAppLink = () => {
  const encodedMessage = encodeURIComponent(siteConfig.whatsappMessage);
  const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isMobileDevice) {
    return `https://wa.me/${siteConfig.whatsappNumber}?text=${encodedMessage}`;
  }

  return `https://web.whatsapp.com/send?phone=${siteConfig.whatsappNumber}&text=${encodedMessage}`;
};

export const getWhatsAppWebLink = () => {
  const encodedMessage = encodeURIComponent(siteConfig.whatsappMessage);
  return `https://wa.me/${siteConfig.whatsappNumber}?text=${encodedMessage}`;
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Courses", path: "/courses" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

export const mediaChannels = [
  {
    id: "spotify",
    label: "Spotify",
    url: siteConfig.spotifyPodcastUrl,
  },
  {
    id: "apple-podcasts",
    label: "Apple Podcasts",
    url: siteConfig.applePodcastUrl,
  },
  {
    id: "youtube",
    label: "YouTube",
    url: siteConfig.youtubeUrl,
  },
];

export const benefits = [
  {
    title: "Conversational First",
    description: "Start speaking practical Hindi from day one for real-life situations, not textbook-only drills.",
  },
  {
    title: "Tailored to Your Role",
    description: "Lessons are personalized for diplomats, embassy families, corporate expats, and global professionals.",
  },
  {
    title: "Culture Included",
    description: "Learn tone, etiquette, and cultural context so your Hindi works naturally in India.",
  },
  {
    title: "Flexible Format",
    description: "Train online worldwide or in-person in Delhi with schedules designed for expat lifestyles.",
  },
];

export const courses = [
  {
    name: "Essentials Hindi",
    subtitle: "For newcomers settling into India",
    lessons: "1-hour live class • Survival Hindi for daily life",
    recommendedPlan: "12 weeks • minimum 3 classes per week",
    features: [
      "Everyday phrases & greetings",
      "Numbers + practical vocabulary",
      "Worksheets + free learning materials included",
    ],
  },
  {
    name: "Diplomatic Hindi",
    subtitle: "Tailored for embassy staff and diplomats",
    lessons: "1-hour live class • Formal + conversational Hindi",
    recommendedPlan: "6 months • 2 classes per week",
    features: [
      "Formal communication practice",
      "Cultural protocol orientation",
      "Worksheets + free learning materials included",
    ],
  },
  {
    name: "Family Programme",
    subtitle: "For expat families and spouses",
    lessons: "1-hour live class • Home, school, market & social Hindi",
    recommendedPlan: "6–8 months • 1 class per week",
    features: [
      "Learn together as a family",
      "Practical Delhi-life communication",
      "Worksheets + free learning materials included",
    ],
  },
  {
    name: "Kids Hindi Programme",
    subtitle: "For children learning spoken + reading confidence",
    lessons: "1-hour live class • Spoken, reading, writing & comprehension",
    recommendedPlan: "6–9 months • 2 classes per week",
    features: [
      "Storytelling, flashcards, and interactive games",
      "Age-appropriate worksheets + free learning materials",
      "Parent communication and regular progress feedback",
    ],
  },
];

export const globalLearnerRegions = [
  "United States",
  "Italy",
  "Poland",
  "France",
  "Germany",
  "Denmark",
  "British schools",
  "American schools",
];

export const testimonials = [
  {
    name: "Nicolai Mantzius",
    location: "Denmark (Adult)",
    feedback: "Hindi classes with Prabha were not only insightful into the language, but also the culture.",
  },
  {
    name: "Tony Senanayake",
    location: "Australia (Adult)",
    avatar: "https://customer-assets.emergentagent.com/job_hindi-master-class/artifacts/wnj801cm_195a473b-e676-4600-bd39-547eb9c941f1.JPG",
    feedback:
      "If you are looking for a high-quality Hindi tutor who can effectively teach from the bare basics, I highly recommend Prabha Ma’am.",
  },
  {
    name: "Astha Jain",
    location: "New York",
    feedback:
      "Prabha has been teaching my older daughter (10) for three years, and my younger daughter (6) for almost two years. Despite virtual learning, she has managed to engage both children positively in their spoken, reading, writing and comprehension. She has taught them everything from the alphabet to reading comprehension of short story books, from understanding basic words to understanding stories. Thanks to Prabha, they are proud of their hindi skills and of their Indian heritage, and we as parents are proud of what they have accomplished.",
  },
  {
    name: "Fairy",
    location: "New York",
    feedback:
      "We had tried numerous classes before and my child did not like them and didn't want to learn Hindi. It has been challenging because we live abroad and don't speak Hindi at home. She is so much more engaged with Prabha! She is learning incredibly well and actually enjoying it. The material is presented in a way that she can understand, and Prabha is so patient with her. She also provides excellent homework and communication with parents to make sure our goals are aligned on an ongoing basis. We highly recommend Prabha to everyone.",
  },
  {
    name: "Ankita Anand",
    location: "U.K",
    feedback:
      "We are very grateful to have Prabha as our child’s Hindi teacher. She is wonderful with the kids and truly has a thoughtful, caring approach to teaching. What we appreciate most is how she takes the time to understand each child individually and works at the child’s own pace. This has helped our child build both language skills and confidence. Prabha is friendly, patient, and dedicated. She creates a comfortable and encouraging learning environment, which makes a big difference. Our child is very happy and feels completely at ease with her — which is always a great sign. We highly recommend Prabha to any parent looking for a supportive and effective Hindi teacher.",
  },
  {
    name: "Iglika Georgieva",
    location: "Sofia, Bulgaria",
    feedback:
      "Prabha is a wonderful Hindi teacher — patient, kind, and very encouraging. She explains things clearly and makes learning Hindi feel natural and enjoyable. Her classes are structured but also very relaxed, which helps build confidence while speaking. I truly enjoy learning with her and would highly recommend her to anyone who wants to learn Hindi in a supportive and positive environment.",
  },
];

export const faqItems = [
  {
    question: "Do I need to know Hindi script before joining?",
    answer: "No. We begin with spoken Hindi and practical conversation first. Script can be added later if needed.",
  },
  {
    question: "Do you teach diplomats and embassy families?",
    answer: "Yes. Prabha specializes in diplomatic and expat-focused Hindi, including cultural protocol and practical communication.",
  },
  {
    question: "Can I book a free trial class first?",
    answer: "Yes. You can book a complimentary 30-minute trial session with no commitment.",
  },
];

export const heroImage = "/images/hindi-chart-cleaned-v2.jpg";

export const teacherImage = "/images/teacher-prabha-edited.jpg";

export const freeMaterialVisuals = {
  adults:
    "https://images.unsplash.com/photo-1578583938317-2e807975085d?auto=format&fit=crop&w=1600&q=90",
  kids:
    "https://images.unsplash.com/photo-1637148734636-906c24feeb55?auto=format&fit=crop&w=1600&q=90",
};

export const adultsHindiHinglishChart = [
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4a7.svg",
    hindi: "पानी",
    hinglish: "paani",
    english: "water",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f37d.svg",
    hindi: "खाना",
    hinglish: "khaana",
    english: "meal",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4b0.svg",
    hindi: "कितने पैसे",
    hinglish: "kitne paise",
    english: "how much money",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f695.svg",
    hindi: "टैक्सी",
    hinglish: "taxi",
    english: "taxi",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f6cd.svg",
    hindi: "बाज़ार",
    hinglish: "bazaar",
    english: "market",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f64f.svg",
    hindi: "धन्यवाद",
    hinglish: "dhanyavaad",
    english: "thank you",
  },
];

export const kidsHindiHinglishChart = [
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f392.svg",
    hindi: "बैग",
    hinglish: "bag",
    english: "school bag",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4d8.svg",
    hindi: "किताब",
    hinglish: "kitaab",
    english: "book",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4a7.svg",
    hindi: "पानी",
    hinglish: "paani",
    english: "water",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f3b2.svg",
    hindi: "खेलो",
    hinglish: "khelo",
    english: "play",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f4d6.svg",
    hindi: "पढ़ो",
    hinglish: "padho",
    english: "read",
  },
  {
    iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/2600.svg",
    hindi: "सूरज",
    hinglish: "suraj",
    english: "sun",
  },
];

export const hindiAlphabetStarterChart = [
  { hindi: "अ", hinglish: "a" },
  { hindi: "आ", hinglish: "aa" },
  { hindi: "इ", hinglish: "i" },
  { hindi: "ई", hinglish: "ee" },
  { hindi: "उ", hinglish: "u" },
  { hindi: "ऊ", hinglish: "oo" },
  { hindi: "ए", hinglish: "e" },
  { hindi: "ओ", hinglish: "o" },
];

export const freeHindiResources = [
  {
    id: "fruits-and-vegetables",
    title: "Fruits and Vegetables Hindi",
    description: "Beginner Hindi words for fruits and vegetables with simple practice.",
    audience: "Adults and Kids",
    url: "/resources/fruits_vegetables_hindi-2.pdf",
  },
  {
    id: "at-home-hindi-single",
    title: "At Home Hindi",
    description: "Basic at-home Hindi words and day-to-day usage lines.",
    audience: "Adults and Kids",
    url: "/resources/at_home_hindi_single.pdf",
  },
];